var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-size-details"},[_vm._v("基金持仓")])
}
var staticRenderFns = []

export { render, staticRenderFns }